module.exports = __webpack_public_path__ + "img/download-app.88199c24.svg";